export enum IntegrationId {
  AWS = "aws",
  AZURE = "azure",
  AZURE_DEVOPS = "azure-devops",
  BACKSTAGE = "backstage",
  BITBUCKET_CLOUD = "bitbucket-cloud",
  BITBUCKET_DATA_CENTER = "bitbucket-data-center",
  BLOB_STORAGE = "blob-storage",
  DATADOG = "datadog",
  GCP = "gcp",
  GITHUB = "github",
  GITLAB = "gitlab",
  ORIGIN = "origin",
  GRAPHQL_API = "graphql-api",
  SERVICENOW = "servicenow",
  SLACK = "slack",
  SPACECTL = "spacectl",
  TEAMS = "teams",
  TERRAFORM_PROVIDER = "terraform-provider",
  VCS_AGENT_POOLS = "vcs-agent-pools",
  WEBHOOKS = "webhooks",
  AI = "ai",
}
